(function () {
  if (window.__teaQuizConstitutionLiveFixV2 || window.__teaQuizRenderConstitutionHub) return;
  if (window.__teaQuizConstitutionLiveFixV1) return;
  window.__teaQuizConstitutionLiveFixV1 = 1;

  var HUB_VIEW = 'quiz-results';
  var STORAGE_KEY = 'teaQuizConstitutionResults';
  var RAW_SCORES_KEY = 'teaQuizRawScores';
  var SCORE_THRESHOLD = 9;
  var CONSTITUTION_NAMES = ['気虚', '血虚', '気滞', '陰虚', '陽虚', '痰湿', '瘀血', '平和'];

  window.__teaQuizHubRedirectLock = 0;
  try {
    sessionStorage.removeItem('teaQuizHubRedirectLock');
  } catch (error) {}

  function getRoot() {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return root.charAt(root.length - 1) === '/' ? root : root + '/';
  }

  function escapeHtml(text) {
    return String(text)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function buildHubUrl() {
    return getRoot() + '?from=quiz&view=' + HUB_VIEW;
  }

  function buildDetailUrl(name) {
    return getRoot() + 'collections/' + encodeURIComponent(name) + '?from=quiz&view=detail#constitution-info';
  }

  function isHubResultsUrl() {
    try {
      return new URLSearchParams(window.location.search).get('view') === HUB_VIEW;
    } catch (error) {
      return window.location.search.indexOf('view=' + HUB_VIEW) !== -1;
    }
  }

  function quizLooksLikeResult() {
    if (window.Quiz && window.Quiz.context && window.Quiz.context.mode === 'result') return true;
    var hosts = document.querySelectorAll('#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz');
    for (var i = 0; i < hosts.length; i++) {
      var shadow = hosts[i].shadowRoot;
      if (!shadow) continue;
      if (shadow.querySelector('.quiz-question')) return false;
      if (shadow.querySelector('.quiz-result, .result-page, .quiz.results')) return true;
    }
    return false;
  }

  window.__teaQuizLooksLikeResult = quizLooksLikeResult;

  function findHubRoot() {
    return (
      document.querySelector('.quiz-constitution-results-section [data-quiz-constitution-results]') ||
      document.querySelector('#quiz-results [data-quiz-constitution-results]') ||
      document.querySelector('[data-quiz-constitution-results]')
    );
  }

  function hubPaintComplete() {
    var root = findHubRoot();
    if (!root) return false;
    return !!(
      root.querySelector('.quiz-constitution-results__grid') ||
      root.querySelector('.quiz-constitution-results__empty')
    );
  }

  function shouldSkipHubTransition() {
    if (window.__teaQuizHubTransitionDone && hubPaintComplete()) return true;
    if (isHubResultsUrl()) return false;
    if (quizLooksLikeResult()) return false;
    if (window.location.hash === '#quiz') return true;
    if (document.documentElement.classList.contains('tea-quiz-take-mode')) return true;
    try {
      if (window.location.search.indexOf('_teaquizretake=') >= 0) return true;
      if (sessionStorage.getItem('teaQuizBlockRedirect') === '1') return true;
      if (sessionStorage.getItem('teaQuizExplicitRetake') === '1') return true;
    } catch (error) {}
    return false;
  }

  function injectRescueCss() {
    if (document.getElementById('tea-quiz-hub-results-rescue-css')) return;
    var style = document.createElement('style');
    style.id = 'tea-quiz-hub-results-rescue-css';
    style.textContent =
      'html.quiz-results-from-quiz #quiz,' +
      'html.quiz-results-from-quiz #quiz-container,' +
      'html.quiz-results-from-quiz #shadow-quiz,' +
      'html.quiz-results-from-quiz .shopify-section:has(#quiz),' +
      'html.quiz-results-from-quiz .shopify-section:has(#shadow-quiz){display:none!important;}' +
      'html.quiz-results-from-quiz .quiz-constitution-results-section,' +
      'html.quiz-results-from-quiz #quiz-results,' +
      'html.quiz-results-from-quiz [data-quiz-constitution-results]{display:block!important;}';
    document.head.appendChild(style);
  }

  function hideQuizSurface() {
    document.documentElement.classList.add('quiz-results-from-quiz');
    document.documentElement.classList.remove('tea-quiz-take-mode');
    document
      .querySelectorAll(
        '#shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz, #quiz, #quiz-container, .shopify-section:has(#quiz), .shopify-section:has(#shadow-quiz)'
      )
      .forEach(function (node) {
        node.style.setProperty('display', 'none', 'important');
      });
  }

  function readLiveScores() {
    if (window.Quiz && window.Quiz.variableScores) return window.Quiz.variableScores;
    if (window.quiz && window.quiz.variableScores) return window.quiz.variableScores;
    if (window.quiz && window.quiz.variables && window.quiz.variables.scores) {
      return window.quiz.variables.scores;
    }
    return null;
  }

  function normalizeScores(raw) {
    if (!raw || typeof raw !== 'object') return null;
    var source = raw;
    if (raw.scores && typeof raw.scores === 'object') source = raw.scores;
    var normalized = {};
    var hasValue = false;
    CONSTITUTION_NAMES.forEach(function (name) {
      var score = 0;
      if (source[name] != null) {
        score = Number(source[name]) || 0;
      } else {
        Object.keys(source).forEach(function (key) {
          if (String(key).replace(/\s/g, '') === name) score = Number(source[key]) || 0;
        });
      }
      if (score > 0) hasValue = true;
      normalized[name] = score;
    });
    return hasValue ? normalized : null;
  }

  function buildQualified(scores) {
    var list = [];
    CONSTITUTION_NAMES.forEach(function (name) {
      var score = Number(scores && scores[name] != null ? scores[name] : 0);
      if (score >= SCORE_THRESHOLD) list.push({ name: name, score: score, percent: 0 });
    });
    if (!list.length) return null;
    list.sort(function (a, b) {
      return b.score - a.score;
    });
    if (list.length === 1) {
      list[0].percent = 100;
      return list;
    }
    var total = 0;
    list.forEach(function (item) {
      total += item.score;
    });
    var assigned = 0;
    list.forEach(function (item, index) {
      if (index === list.length - 1) {
        item.percent = Math.max(0, 100 - assigned);
        return;
      }
      item.percent = total > 0 ? Math.round((item.score / total) * 100) : 0;
      assigned += item.percent;
    });
    return list;
  }

  function totalQualifiedScore(qualified) {
    var total = 0;
    qualified.forEach(function (item) {
      total += item.score;
    });
    return total;
  }

  function shouldReplacePersistedResults(qualified) {
    var existing = readPersistedResults();
    if (!existing || !existing.qualified || !existing.qualified.length) return true;
    if (qualified.length > existing.qualified.length) return true;
    if (qualified.length < existing.qualified.length) return false;
    return totalQualifiedScore(qualified) >= totalQualifiedScore(existing.qualified);
  }

  function persistResults(qualified, scores) {
    if (!shouldReplacePersistedResults(qualified)) return;
    try {
      var payload = JSON.stringify({ qualified: qualified, savedAt: Date.now() });
      sessionStorage.setItem(STORAGE_KEY, payload);
      try {
        localStorage.setItem(STORAGE_KEY, payload);
      } catch (error) {}
      if (scores) {
        var rawPayload = JSON.stringify(scores);
        sessionStorage.setItem(RAW_SCORES_KEY, rawPayload);
        try {
          localStorage.setItem(RAW_SCORES_KEY, rawPayload);
        } catch (error) {}
      }
    } catch (error) {}
  }

  function readPersistedResults() {
    try {
      var raw = sessionStorage.getItem(STORAGE_KEY);
      if (!raw) {
        raw = localStorage.getItem(STORAGE_KEY);
      }
      if (!raw) return null;
      var parsed = JSON.parse(raw);
      if (!parsed || !Array.isArray(parsed.qualified) || !parsed.qualified.length) return null;
      return parsed;
    } catch (error) {
      return null;
    }
  }

  function hubRenderedQualifiedCount(root) {
    if (!root) return 0;
    var grid = root.querySelector('.quiz-constitution-results__grid');
    if (!grid) return 0;
    return grid.querySelectorAll('.quiz-constitution-results__card').length;
  }

  function renderHubCards(root) {
    if (!root) return false;
    var data = readPersistedResults();
    if (!data) return false;
    if (
      root.querySelector('.quiz-constitution-results__grid') &&
      hubRenderedQualifiedCount(root) === data.qualified.length
    ) {
      return true;
    }
    var cards = data.qualified
      .map(function (item) {
        var percent = typeof item.percent === 'number' ? item.percent : 0;
        return (
          '<a class="quiz-constitution-results__card" href="' +
          escapeHtml(buildDetailUrl(item.name)) +
          '"><span class="quiz-constitution-results__card-name">' +
          escapeHtml(item.name) +
          '</span><span class="quiz-constitution-results__card-percent">' +
          escapeHtml(String(percent)) +
          '<span class="quiz-constitution-results__card-percent-sign">%</span></span><span class="quiz-constitution-results__card-action">くわしく見る</span></a>'
        );
      })
      .join('');
    root.innerHTML =
      '<div class="quiz-constitution-results__inner page-width"><header class="quiz-constitution-results__header">' +
      '<p class="quiz-constitution-results__eyebrow">体質チェックの結果</p>' +
      '<h1 class="quiz-constitution-results__title">あなたに当てはまる体質</h1>' +
      '<p class="quiz-constitution-results__lead">回答内容から、9点以上となった体質を表示しています。気になる体質をタップして、説明とおすすめのお茶をご覧ください。</p></header>' +
      '<div class="quiz-constitution-results__grid">' +
      cards +
      '</div><p class="quiz-constitution-results__note">※ パーセントは、該当した体質のスコア合計に対する割合です。</p></div>';
    root.dataset.rendered = 'true';
    return true;
  }

  function paintHubRoot(root) {
    if (!root) return hubPaintComplete();
    if (renderHubCards(root)) return true;
    if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.renderHub) {
      return window.TeaQuizConstitutionHub.renderHub(root);
    }
    return false;
  }

  function waitForStableScores(callback) {
    var attempts = 0;
    var maxAttempts = 45;
    var intervalMs = 200;
    var stableNeeded = 3;
    var lastSnapshot = null;
    var stableCount = 0;
    var lastQualifiedCount = -1;
    var qualifiedStableCount = 0;
    var best = null;

    function consider(scores) {
      var qualified = buildQualified(scores);
      if (!qualified || !qualified.length) return;
      var candidate = {
        qualified: qualified,
        scores: scores,
        qualifiedCount: qualified.length,
        totalScore: totalQualifiedScore(qualified)
      };
      if (
        !best ||
        candidate.qualifiedCount > best.qualifiedCount ||
        (candidate.qualifiedCount === best.qualifiedCount && candidate.totalScore > best.totalScore)
      ) {
        best = candidate;
      }
      if (candidate.qualifiedCount === lastQualifiedCount) {
        qualifiedStableCount += 1;
      } else {
        qualifiedStableCount = 0;
        lastQualifiedCount = candidate.qualifiedCount;
      }
    }

    function finish() {
      if (best) {
        persistResults(best.qualified, best.scores);
        callback(best.qualified, best.scores);
        return;
      }
      callback(null, null);
    }

    function tick() {
      attempts += 1;
      var scores = normalizeScores(readLiveScores());
      if (scores) {
        consider(scores);
        if (best) {
          var snapshot = CONSTITUTION_NAMES.map(function (name) {
            return name + ':' + (scores[name] || 0);
          }).join('|');
          if (snapshot === lastSnapshot) {
            stableCount += 1;
          } else {
            stableCount = 1;
            lastSnapshot = snapshot;
          }
          if (stableCount >= stableNeeded && qualifiedStableCount >= 2) {
            finish();
            return;
          }
        }
      }
      if (attempts >= maxAttempts) {
        finish();
        return;
      }
      window.setTimeout(tick, intervalMs);
    }

    tick();
  }

  function scrollToHub() {
    var anchor = document.getElementById('quiz-results');
    if (anchor) {
      window.requestAnimationFrame(function () {
        anchor.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }
  }

  function triggerHubTransition() {
    if (shouldSkipHubTransition()) return;
    document.documentElement.classList.remove('tea-quiz-take-mode');
    window.__teaQuizHubRedirectLock = 0;
    try {
      sessionStorage.removeItem('teaQuizHubRedirectLock');
    } catch (error) {}

    injectRescueCss();

    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var rootPath = getRoot().replace(/\/$/, '') || '/';
    if (path === '/' || path === rootPath) {
      try {
        history.replaceState(null, '', buildHubUrl());
      } catch (error) {}
    }

    function finishPaint() {
      var root = findHubRoot();
      var painted = paintHubRoot(root);
      if (painted) {
        window.__teaQuizHubTransitionDone = 1;
        hideQuizSurface();
        scrollToHub();
      }
      if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.mountHubPage) {
        window.TeaQuizConstitutionHub.mountHubPage();
      }
    }

    waitForStableScores(function () {
      finishPaint();
      window.setTimeout(finishPaint, 300);
      window.setTimeout(finishPaint, 1200);
      window.setTimeout(finishPaint, 3000);
    });

    if (readPersistedResults()) {
      finishPaint();
    }
  }

  window.__teaQuizTryRedirectToResultsHub = function () {
    triggerHubTransition();
    return true;
  };

  window.__teaQuizIsOnHubResultsPage = function () {
    return isHubResultsUrl();
  };

  window.__teaQuizPaintHubNow = triggerHubTransition;
  window.__teaQuizTriggerConstitutionHub = triggerHubTransition;

  window.addEventListener(
    'message',
    function (event) {
      var data = event.data;
      if (!data || data.channel !== 'revenuehunt:quiz-renderer' || data.type !== 'isResult') return;
      if (shouldSkipHubTransition()) return;
      event.stopImmediatePropagation();
      triggerHubTransition();
    },
    true
  );

  function pollQuizResultSurface() {
    if (shouldSkipHubTransition()) return;
    if (!document.querySelector('#shadow-quiz')) return;
    if (!quizLooksLikeResult()) return;
    triggerHubTransition();
  }

  injectRescueCss();
  window.setInterval(pollQuizResultSurface, 250);

  function isHomePath() {
    var path = (window.location.pathname || '').replace(/\/$/, '') || '/';
    var rootPath = getRoot().replace(/\/$/, '') || '/';
    return path === '/' || path === rootPath;
  }

  function restoreQuizSectionDisplay() {
    document
      .querySelectorAll(
        '#quiz, #quiz-container, #shadow-quiz, #quiz #shadow-quiz, #quiz-container #shadow-quiz, .shopify-section:has(#quiz), .shopify-section:has(#shadow-quiz)'
      )
      .forEach(function (node) {
        node.style.removeProperty('display');
      });
  }

  function cleanStaleHubUrl() {
    try {
      var path = window.location.pathname || '/';
      var hash = window.location.hash || '';
      history.replaceState(null, '', path + hash);
    } catch (error) {}
  }

  function enableQuizTakeModeView() {
    document.documentElement.classList.add('tea-quiz-take-mode');
    document.documentElement.classList.remove('quiz-results-from-quiz');
    window.__teaQuizHubTransitionDone = 0;
    restoreQuizSectionDisplay();
    if (window.__teaQuizEnableTakeMode) {
      window.__teaQuizEnableTakeMode();
    } else if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.enableQuizTakeMode) {
      window.TeaQuizConstitutionHub.enableQuizTakeMode();
    }
  }

  function showNormalHomepageQuiz() {
    document.documentElement.classList.remove('quiz-results-from-quiz');
    document.documentElement.classList.remove('tea-quiz-take-mode');
    window.__teaQuizHubTransitionDone = 0;
    restoreQuizSectionDisplay();
  }

  function showHubResultsView() {
    document.documentElement.classList.add('quiz-results-from-quiz');
    document.documentElement.classList.remove('tea-quiz-take-mode');
    if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.mountHubPage) {
      window.TeaQuizConstitutionHub.mountHubPage();
    }
  }

  function applyHomepageQuizVisibility() {
    if (!isHomePath()) return;

    if (window.location.hash === '#quiz') {
      if (isHubResultsUrl()) {
        cleanStaleHubUrl();
      }
      enableQuizTakeModeView();
      return;
    }

    if (isHubResultsUrl()) {
      if (!readPersistedResults() && !quizLooksLikeResult()) {
        cleanStaleHubUrl();
        showNormalHomepageQuiz();
        return;
      }
      showHubResultsView();
      return;
    }

    showNormalHomepageQuiz();
  }

  function scheduleHomepageGuards() {
    applyHomepageQuizVisibility();
    [50, 150, 400, 1000, 2000, 4000].forEach(function (delay) {
      window.setTimeout(applyHomepageQuizVisibility, delay);
    });
  }

  window.__teaQuizRestoreHomepageQuiz = applyHomepageQuizVisibility;
  scheduleHomepageGuards();
  window.addEventListener('pageshow', scheduleHomepageGuards);
  window.addEventListener('hashchange', applyHomepageQuizVisibility);
  window.addEventListener('DOMContentLoaded', scheduleHomepageGuards);

  if (isHubResultsUrl() && window.location.hash !== '#quiz') {
    if (readPersistedResults() || quizLooksLikeResult()) {
      document.documentElement.classList.add('quiz-results-from-quiz');
      document.documentElement.classList.remove('tea-quiz-take-mode');
      window.setTimeout(function () {
        if (window.TeaQuizConstitutionHub && window.TeaQuizConstitutionHub.mountHubPage) {
          window.TeaQuizConstitutionHub.mountHubPage();
        } else {
          triggerHubTransition();
        }
      }, 0);
    } else {
      cleanStaleHubUrl();
      showNormalHomepageQuiz();
    }
  }
})();

(function () {
  if ((window.__teaQuizNavPatch || 0) >= 7) return;
  window.__teaQuizNavPatch = 7;

  function isQuizActive() {
    return !!document.getElementById('quiz-container') || window.location.hash === '#quiz';
  }

  function isOnHomePath() {
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root_url) || '/';
    var cleanRoot = rootUrl.split('?')[0] || '/';
    if (cleanRoot !== '/') {
      return window.location.pathname === cleanRoot;
    }
    return window.location.pathname === '/' || window.location.pathname === '';
  }

  function isBareHomeUrl(url) {
    if (!url) return false;
    var urlStr = String(url);
    var origin = window.location.origin;
    if (urlStr.indexOf(origin) !== 0) return false;
    if (urlStr.indexOf('_teahome') >= 0) return false;
    var rest = urlStr.slice(origin.length).split('?')[0].split('#')[0] || '/';
    return rest === '/' || rest === '';
  }

  function shouldInterceptHomeNavigation(url) {
    if (!isBareHomeUrl(url)) return false;
    if (isQuizActive()) return true;
    if (isOnHomePath()) return true;
    try {
      if (sessionStorage.getItem('teaQuizReturnHome') === '1') return true;
    } catch (error) {}
    return false;
  }

  function scrollToTopHard() {
    if ('scrollRestoration' in window.history) {
      window.history.scrollRestoration = 'manual';
    }
    var scrollToTop = function () {
      window.scrollTo(0, 0);
      if (document.documentElement) document.documentElement.scrollTop = 0;
      if (document.body) document.body.scrollTop = 0;
    };
    scrollToTop();
    requestAnimationFrame(scrollToTop);
    setTimeout(scrollToTop, 50);
    setTimeout(scrollToTop, 200);
    setTimeout(scrollToTop, 500);
  }

  function closeQuizAndReturnHome() {
    if (window.teaQuizGoToTopPage) {
      window.teaQuizGoToTopPage();
      return;
    }
    if (window.teaQuizApplyHomeReset) {
      window.teaQuizApplyHomeReset();
      return;
    }

    try {
      if (window.revenueHuntQuizPopup && typeof window.revenueHuntQuizPopup.close === 'function') {
        window.revenueHuntQuizPopup.close({ clearHash: true });
      } else if (window.revenueHuntCloseQuizContainer) {
        window.revenueHuntCloseQuizContainer({ clearHash: true });
      }
      if (window.revenueHuntQuizHash && typeof window.revenueHuntQuizHash.clear === 'function') {
        window.revenueHuntQuizHash.clear();
      }
    } catch (error) {}

    var quizContainer = document.getElementById('quiz-container');
    if (quizContainer) quizContainer.remove();

    document.body.classList.remove('revenuehunt-popup-open');
    document.body.style.removeProperty('--quiz-dropdown-z-index');

    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root_url) || '/';
    var cleanRoot = rootUrl.split('?')[0] || '/';

    window.location.href = window.location.origin + cleanRoot + '?_teahome=1';
  }

  window.teaQuizCloseAndReturnHome = closeQuizAndReturnHome;
  window.teaQuizGoHome = closeQuizAndReturnHome;
  window.__teaQuizHomeLoaded = true;
  window.__teaQuizHomeVersion = 7;

  function patchLocationMethod(methodName) {
    var key = '__teaQuiz' + methodName + 'PatchedV7';
    if (Location.prototype[key]) return;
    Location.prototype[key] = true;
    var original = Location.prototype[methodName];
    Location.prototype[methodName] = function (url) {
      if (shouldInterceptHomeNavigation(url)) {
        closeQuizAndReturnHome();
        return;
      }
      return original.call(this, url);
    };
  }

  patchLocationMethod('replace');
  patchLocationMethod('assign');

  function handleReturnHomeScroll() {
    var returnFromQuiz = false;
    try {
      returnFromQuiz =
        window.location.search.indexOf('_teahome=') >= 0 ||
        sessionStorage.getItem('teaQuizReturnHome') === '1';
      if (sessionStorage.getItem('teaQuizReturnHome') === '1') {
        sessionStorage.removeItem('teaQuizReturnHome');
      }
    } catch (error) {}
    if (!returnFromQuiz) return;

    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.pathname);
    }
    scrollToTopHard();
    document.addEventListener('DOMContentLoaded', scrollToTopHard);
    window.addEventListener('pageshow', function (event) {
      if (returnFromQuiz || event.persisted) scrollToTopHard();
    });
    window.addEventListener('load', scrollToTopHard);
  }
  handleReturnHomeScroll();

  if ((window.__teaQuizHomeClickBound || 0) >= 7) return;
  window.__teaQuizHomeClickBound = 7;

  function findInPath(event, selector) {
    var path = event.composedPath ? event.composedPath() : [event.target];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (!node || node === document || node === window) continue;
      if (node.matches && node.matches(selector)) return node;
      if (node.closest && node.closest(selector)) return node.closest(selector);
    }
    return null;
  }

  function isHomeLogoLink(node) {
    if (!node || !node.matches) return false;
    var rootUrl = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root_url) || '/';
    var origin = window.location.origin;
    return (
      node.matches('a.header__heading-link') ||
      node.matches('a[href="/"]') ||
      node.matches('a[href="' + rootUrl + '"]') ||
      node.matches('a[href="' + origin + '"]') ||
      node.matches('a[href="' + origin + '/"]')
    );
  }

  document.addEventListener(
    'click',
    function (event) {
      if (findInPath(event, '.tea-quiz-home-button')) {
        event.preventDefault();
        event.stopImmediatePropagation();
        closeQuizAndReturnHome();
        return;
      }

      if (!isQuizActive()) return;

      var path = event.composedPath ? event.composedPath() : [event.target];
      for (var i = 0; i < path.length; i++) {
        if (isHomeLogoLink(path[i])) {
          event.preventDefault();
          event.stopImmediatePropagation();
          closeQuizAndReturnHome();
          return;
        }
      }
    },
    true
  );

  window.setInterval(function () {
    window.teaQuizGoHome = closeQuizAndReturnHome;
    window.teaQuizCloseAndReturnHome = closeQuizAndReturnHome;
  }, 300);
})();

window.TeaCatalog = (function () {
  var EFFECTS = {
    '山薬': '気を補い体力を養う',
    '乾生姜': '体を温め胃腸を整える',
    '大棗': '心身を養い味を調える',
    '陳皮': '気の巡りを助け胃を整える',
    '蒲公英': '熱を清め解毒をサポート',
    '玫瑰花': '気の滞りをゆるめ心を穏やかに',
    '金銀花': '熱を解き清らかな状態へ',
    '山査子': '消化を助け滞りを解消',
    '茉莉花': '気を疏げストレスを和らげる',
    '紅花': '血の巡りを促す',
    '枸杞子': '肝腎を養い潤いを与える',
    '竹葉': '心火を清め気持ちを安定',
    '桑の実': '血を養い潤いを補う',
    '桑葉': '風熱を清め潤いを保つ',
    '杜仲葉': '腰腎を補い活力を支える',
    'ハトムギ': '湿気を取り利尿を助ける',
    '桂皮': '体を温め血行を促す',
    '蓮葉': '暑熱を解きさっぱりと',
    'ペパーミント': '気を疏げ爽快に',
    '南蛮毛': '温陽散寒、冷えを改善',
    '五味子': '陰を養い収斂を助ける',
    '菊花': '風熱を清め目を潤す',
    '黒豆': '腎を養い滋養を与える',
    '決明子': '肝の熱を清め目を潤す'
  };

  var TEA_DATA = {
    '六然薬茶-気虚': [
      ['山薬', EFFECTS['山薬']],
      ['乾生姜', EFFECTS['乾生姜']],
      ['大棗', EFFECTS['大棗']],
      ['陳皮', EFFECTS['陳皮']],
      ['蒲公英', EFFECTS['蒲公英']]
    ],
    '六然薬茶-気滞': [
      ['玫瑰花', EFFECTS['玫瑰花']],
      ['陳皮', EFFECTS['陳皮']],
      ['金銀花', EFFECTS['金銀花']],
      ['山査子', EFFECTS['山査子']],
      ['茉莉花', EFFECTS['茉莉花']]
    ],
    '六然薬茶-血虚': [
      ['紅花', EFFECTS['紅花']],
      ['大棗', EFFECTS['大棗']],
      ['枸杞子', EFFECTS['枸杞子']],
      ['竹葉', EFFECTS['竹葉']],
      ['桑の実', EFFECTS['桑の実']]
    ],
    '六然薬茶-陽虚': [
      ['杜仲葉', EFFECTS['杜仲葉']],
      ['ハトムギ', EFFECTS['ハトムギ']],
      ['桂皮', EFFECTS['桂皮']],
      ['陳皮', EFFECTS['陳皮']],
      ['乾生姜', EFFECTS['乾生姜']]
    ],
    '六然薬茶-陰虚': [
      ['桑葉', EFFECTS['桑葉']],
      ['五味子', EFFECTS['五味子']],
      ['桑の実', EFFECTS['桑の実']],
      ['枸杞子', EFFECTS['枸杞子']],
      ['菊花', EFFECTS['菊花']],
      ['黒豆', EFFECTS['黒豆']]
    ],
    '六然薬茶-痰湿': [
      ['ハトムギ', EFFECTS['ハトムギ']],
      ['蓮葉', EFFECTS['蓮葉']],
      ['南蛮毛', EFFECTS['南蛮毛']],
      ['陳皮', EFFECTS['陳皮']],
      ['蒲公英', EFFECTS['蒲公英']]
    ],
    '六然薬茶-瘀血': [
      ['紅花', EFFECTS['紅花']],
      ['玫瑰花', EFFECTS['玫瑰花']],
      ['大棗', EFFECTS['大棗']],
      ['桑葉', EFFECTS['桑葉']]
    ],
    '六然薬茶-平和': [
      ['桑葉', EFFECTS['桑葉']],
      ['ハトムギ', EFFECTS['ハトムギ']],
      ['陳皮', EFFECTS['陳皮']],
      ['枸杞子', EFFECTS['枸杞子']],
      ['黒豆', EFFECTS['黒豆']],
      ['菊花', EFFECTS['菊花']]
    ],
    '六然薬茶-美': [
      ['玫瑰花', EFFECTS['玫瑰花']],
      ['枸杞子', EFFECTS['枸杞子']],
      ['大棗', EFFECTS['大棗']],
      ['ハトムギ', EFFECTS['ハトムギ']],
      ['杜仲葉', EFFECTS['杜仲葉']],
      ['黒豆', EFFECTS['黒豆']]
    ],
    '六然薬茶-春': [
      ['枸杞子', EFFECTS['枸杞子']],
      ['菊花', EFFECTS['菊花']],
      ['茉莉花', EFFECTS['茉莉花']],
      ['蒲公英', EFFECTS['蒲公英']],
      ['決明子', EFFECTS['決明子']]
    ],
    '六然薬茶-夏': [
      ['竹葉', EFFECTS['竹葉']],
      ['金銀花', EFFECTS['金銀花']],
      ['蓮葉', EFFECTS['蓮葉']],
      ['ペパーミント', EFFECTS['ペパーミント']],
      ['陳皮', EFFECTS['陳皮']]
    ],
    '六然薬茶-梅雨': [
      ['ハトムギ', EFFECTS['ハトムギ']],
      ['茉莉花', EFFECTS['茉莉花']],
      ['蒲公英', EFFECTS['蒲公英']],
      ['南蛮毛', EFFECTS['南蛮毛']],
      ['ペパーミント', EFFECTS['ペパーミント']]
    ],
    '六然薬茶-秋': [
      ['山薬', EFFECTS['山薬']],
      ['枸杞子', EFFECTS['枸杞子']],
      ['桑葉', EFFECTS['桑葉']],
      ['五味子', EFFECTS['五味子']],
      ['茉莉花', EFFECTS['茉莉花']]
    ],
    '六然薬茶-冬': [
      ['枸杞子', EFFECTS['枸杞子']],
      ['杜仲葉', EFFECTS['杜仲葉']],
      ['桂皮', EFFECTS['桂皮']],
      ['大棗', EFFECTS['大棗']],
      ['黒豆', EFFECTS['黒豆']],
      ['乾生姜', EFFECTS['乾生姜']]
    ]
  };

  var BODY_HANDLES = [
    '六然薬茶-気虚',
    '六然薬茶-気滞',
    '六然薬茶-血虚',
    '六然薬茶-陽虚',
    '六然薬茶-陰虚',
    '六然薬茶-痰湿',
    '六然薬茶-瘀血',
    '六然薬茶-平和',
    '六然薬茶-美'
  ];

  var SEASON_HANDLES = [
    '六然薬茶-春',
    '六然薬茶-梅雨',
    '六然薬茶-夏',
    '六然薬茶-秋',
    '六然薬茶-冬'
  ];

  var SEASON_LABELS = {
    '六然薬茶-春': '春',
    '六然薬茶-梅雨': '梅雨',
    '六然薬茶-夏': '夏',
    '六然薬茶-秋': '秋',
    '六然薬茶-冬': '冬'
  };

  var SEASON_TAGLINES = {
    '六然薬茶-春': '春の不調を先取りしたい方に',
    '六然薬茶-梅雨': 'ジメジメが苦手な方に',
    '六然薬茶-夏': '暑さでバテ気味の方に',
    '六然薬茶-秋': '乾燥が気になる方に',
    '六然薬茶-冬': 'まだ冷えやだるさが残る方に'
  };

  var SEASON_SIMILAR_OVERRIDES = {
    '六然薬茶-春': ['六然薬茶-陰虚', '六然薬茶-気滞']
  };

  function ingredientNames(handle) {
    var items = TEA_DATA[handle];
    if (!items) return [];
    return items.map(function (item) { return item[0]; });
  }

  function ingredientSet(handle) {
    var set = {};
    ingredientNames(handle).forEach(function (name) {
      set[name] = true;
    });
    return set;
  }

  function overlapNames(sourceHandle, targetHandle) {
    var source = ingredientSet(sourceHandle);
    return ingredientNames(targetHandle).filter(function (name) {
      return source[name];
    });
  }

  function isBodyTea(handle) {
    return BODY_HANDLES.indexOf(handle) !== -1;
  }

  function isSeasonTea(handle) {
    return SEASON_HANDLES.indexOf(handle) !== -1;
  }

  function rankSimilarHandles(sourceHandle, candidates, limit) {
    var ranked = candidates
      .filter(function (handle) { return handle !== sourceHandle && TEA_DATA[handle]; })
      .map(function (handle) {
        return {
          handle: handle,
          overlap: overlapNames(sourceHandle, handle)
        };
      })
      .filter(function (entry) { return entry.overlap.length > 0; })
      .sort(function (a, b) { return b.overlap.length - a.overlap.length; });

    if (typeof limit === 'number') {
      ranked = ranked.slice(0, limit);
    }

    return ranked.map(function (entry) {
      return {
        handle: entry.handle,
        overlap: entry.overlap,
        overlapText: entry.overlap.join('・')
      };
    });
  }

  function getSimilarBodyTeas(sourceHandle, limit) {
    if (SEASON_SIMILAR_OVERRIDES[sourceHandle]) {
      return SEASON_SIMILAR_OVERRIDES[sourceHandle].map(function (handle) {
        return {
          handle: handle,
          overlap: overlapNames(sourceHandle, handle),
          overlapText: overlapNames(sourceHandle, handle).join('・')
        };
      });
    }

    return rankSimilarHandles(sourceHandle, BODY_HANDLES, limit || 1);
  }

  function getSimilarForProduct(sourceHandle, limit) {
    if (isSeasonTea(sourceHandle)) {
      return getSimilarBodyTeas(sourceHandle, limit);
    }

    if (isBodyTea(sourceHandle)) {
      return rankSimilarHandles(sourceHandle, BODY_HANDLES, limit || 1);
    }

    return [];
  }

  function seasonKeyToHandle(key) {
    return '六然薬茶-' + key;
  }

  function getCurrentSeasonKeys(date) {
    var now = date || new Date();
    var month = now.getMonth() + 1;
    var day = now.getDate();

    if (month === 2) return ['冬', '春'];
    if (month === 4 && day >= 15) return ['春', '梅雨'];
    if (month === 5 && day >= 15) return ['梅雨', '夏'];
    if (month === 6 || month === 7) return ['梅雨', '夏'];
    if (month === 8 && day >= 15) return ['夏', '秋'];
    if (month === 11) return ['秋', '冬'];

    if (month === 3 || (month === 4 && day < 15)) return ['春'];
    if (month === 5 && day < 15) return ['梅雨'];
    if (month === 8 && day < 15) return ['夏'];
    if (month === 9 || month === 10) return ['秋'];
    if (month === 12 || month === 1) return ['冬'];

    return [];
  }

  function getCurrentSeasonTeas(date) {
    return getCurrentSeasonKeys(date).map(function (key) {
      return seasonKeyToHandle(key);
    });
  }

  return {
    EFFECTS: EFFECTS,
    TEA_DATA: TEA_DATA,
    BODY_HANDLES: BODY_HANDLES,
    SEASON_HANDLES: SEASON_HANDLES,
    SEASON_LABELS: SEASON_LABELS,
    SEASON_TAGLINES: SEASON_TAGLINES,
    ingredientNames: ingredientNames,
    overlapNames: overlapNames,
    getSimilarBodyTeas: getSimilarBodyTeas,
    getSimilarForProduct: getSimilarForProduct,
    getCurrentSeasonTeas: getCurrentSeasonTeas,
    isBodyTea: isBodyTea,
    isSeasonTea: isSeasonTea
  };
})();

(function () {
  var ref = document.querySelector('script[src*="tea-catalog.js"]');
  if (!ref) return;
  var base = ref.src.split('?')[0].replace(/tea-catalog\.js$/, '');

  if (!document.querySelector('script[data-tea-quiz-home]')) {
    var homeScript = document.createElement('script');
    homeScript.src = base + 'tea-quiz-home.js?v=4&_=' + Date.now();
    homeScript.defer = true;
    homeScript.setAttribute('data-tea-quiz-home', '');
    document.body.appendChild(homeScript);
  }
})();
